// src/components/ModalShell.jsx
// Shared dark-fantasy modal shell used by AuthModal, StoreModal, NewsPostModal, etc.
// Completely independent from CheckoutModal — no Minecraft blocks here.

/* ── Decorative rune border ──────────────────────────────────────────────── */
export function RuneBorder({ color = "#c9a84c", opacity = 0.4 }) {
  const runes = "ᚠᚢᚦᚨᚱᚲᚷᚹᚺᚾᛁᛃᛇᛈᛉᛊᛏᛒᛖᛗᛚᛜᛞᛟ";
  const chars = Array.from({ length: 32 }, (_, i) => runes[i % runes.length]);
  return (
    <div style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", opacity }}>
      {chars.map((r, i) => (
        <span key={i} style={{ fontSize: 8, color, fontFamily: "serif", opacity: 0.4 + (i % 3) * 0.2 }}>{r}</span>
      ))}
    </div>
  );
}

/* ── Original dark-fantasy modal shell ───────────────────────────────────── */
export function OriginalModalShell({ children, onClose, maxWidth = 480, noClickClose = false }) {
  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 700,
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: "20px 16px",
      background: "rgba(2,1,8,.78)",
      backdropFilter: "blur(10px)",
      animation: "toa-fadein .2s ease",
    }}
      onClick={e => { if (!noClickClose && e.target === e.currentTarget) onClose(); }}
    >
      <style>{`@keyframes toa-fadein { from{opacity:0} to{opacity:1} }`}</style>
      <div style={{
        width: "100%", maxWidth,
        background: "linear-gradient(170deg,#0d0a1a,#110d22,#0a0810)",
        position: "relative", overflow: "hidden",
        maxHeight: "95vh", overflowY: "auto",
        boxShadow: "0 40px 120px rgba(0,0,0,.9), 0 0 0 1px rgba(123,94,167,.2), inset 0 1px 0 rgba(255,255,255,.04)",
      }}>
        {/* Corner ornaments */}
        {[["0,0","",""], ["0,auto","","scaleX(-1)"], ["auto,0","scaleY(-1)",""], ["auto,auto","scaleY(-1)","scaleX(-1)"]].map(([pos, sy, sx], i) => {
          const [top, bottom] = pos.split(",");
          return (
            <svg key={i} width="32" height="32" viewBox="0 0 32 32" style={{
              position: "absolute",
              top: top !== "auto" ? 0 : "auto",
              bottom: bottom !== "auto" ? 0 : "auto",
              left: i % 2 === 0 ? 0 : "auto",
              right: i % 2 === 1 ? 0 : "auto",
              opacity: .35, pointerEvents: "none", zIndex: 2,
              transform: `${sy} ${sx}`,
            }}>
              <path d="M0 0 L12 0 L12 2 L2 2 L2 12 L0 12 Z" fill="#c9a84c" />
              <path d="M4 4 L8 4 L8 5 L5 5 L5 8 L4 8 Z" fill="#c9a84c" />
            </svg>
          );
        })}

        {/* Top rune band */}
        <div style={{ padding: "10px 20px 0", borderBottom: "1px solid rgba(123,94,167,.15)" }}>
          <RuneBorder color="#c9a84c" opacity={0.3} />
        </div>

        {children}

        {/* Bottom rune band */}
        <div style={{ padding: "0 20px 10px", borderTop: "1px solid rgba(123,94,167,.15)" }}>
          <RuneBorder color="#7b5ea7" opacity={0.25} />
        </div>
      </div>
    </div>
  );
}
